import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Cómo recibo el material después de comprar?',
    a: 'Después de comprar, recibís el acceso al material en tu correo electrónico y podés descargarlo al instante.'
  }, {
    q: '¿Sirve para primaria y secundaria?',
    a: 'Sí. Incluye contenido para ambos niveles.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No. Está pensado para uso directo.'
  }, {
    q: '¿Es material imprimible?',
    a: 'Sí. Podés usarlo digital o imprimirlo.'
  }, {
    q: '¿Cuándo recibo el acceso?',
    a: 'Inmediatamente después de comprar.'
  }, {
    q: '¿Puedo usarlo todo el año?',
    a: 'Sí. Está diseñado para acompañarte durante todo el ciclo lectivo.'
  }, {
    q: '¿Necesito preparar algo antes de usar el material?',
    a: 'No. El sistema está diseñado para uso inmediato. Solo accedés y empezás a utilizarlo.'
  }, {
    q: '¿Puedo adaptar el material a mi forma de enseñar?',
    a: 'Sí. Todo el contenido es flexible y podés ajustarlo según tu estilo y el nivel de tus alumnos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 px-6 bg-[#13132b] pb-24" data-id="element-53">
      <div className="text-center mb-10" data-id="element-54">
        <h2 className="text-2xl font-black text-white mb-2" data-id="element-55">
          PREGUNTAS FRECUENTES
        </h2>
      </div>

      <div className="space-y-3" data-id="element-56">
        {faqs.map((faq, index) => <div key={index} className="bg-white/5 border border-white/10 rounded-xl overflow-hidden transition-colors hover:bg-white/10" data-id="element-57">
            <button className="w-full px-5 py-4 text-left flex items-center justify-between gap-4" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-58">
              <span className="font-bold text-sm text-gray-200" data-id="element-59">{faq.q}</span>
              <ChevronDown className={`w-5 h-5 text-gray-400 shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-60" />
            </button>

            <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-61">
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-62">{faq.a}</p>
            </div>
          </div>)}
      </div>
    </section>;
}